'use client';

export { RecruiterGuideScreen } from './RecruiterGuideScreen';
